/* Loads the next collection page into the grid when the sentinel nears the viewport. */
if ( !customElements.get('collection-infinite-scroll') ) {
  customElements.define('collection-infinite-scroll', class CollectionInfiniteScroll extends HTMLElement {

    connectedCallback() {
      this.link = this.querySelector('[data-infinite-next]');
      if ( !this.link || !('IntersectionObserver' in window) ) return;
      this.classList.add('collection-infinite--js');
      this.observer = new IntersectionObserver(entries => {
        if ( entries.some(entry => entry.isIntersecting) ) this.loadNext();
      }, { rootMargin: '0px 0px 800px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async loadNext() {
      if ( this.loading ) return;
      this.loading = true;
      this.classList.add('collection-infinite--loading');
      try {
        const response = await fetch(this.link.href);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.getElementById('main-collection-product-grid');
        if ( !grid ) throw new Error('Product grid not found');

        grid.querySelectorAll(':scope > .product-item').forEach(item => {
          const node = document.adoptNode(item);
          this.before(node);
          // Same as the filters do after re-rendering: move quick-buy templates into their forms.
          node.querySelectorAll('template').forEach(elm => {
            elm.closest('form')?.append(elm.content.cloneNode(true));
          });
        });

        document.dispatchEvent(new CustomEvent('krown:main-collection-grid:filtered', {
          bubbles: true,
          detail: { gridElement: document.getElementById('CollectionProductGrid') }
        }));

        const next = doc.querySelector('collection-infinite-scroll [data-infinite-next]');
        if ( next ) {
          this.link.href = next.getAttribute('href');
          this.loading = false;
          this.classList.remove('collection-infinite--loading');
          // Re-observe so a sentinel that is still in view triggers the following page.
          this.observer.unobserve(this);
          this.observer.observe(this);
        } else {
          this.remove();
        }
      } catch ( error ) {
        // Fall back to the plain "next page" link.
        this.observer?.disconnect();
        this.classList.remove('collection-infinite--js', 'collection-infinite--loading');
        this.loading = false;
      }
    }

  });
}
